import { bffClient, platformClient } from '@lib/axios';
import type {
  WorkspaceDiscoveryApi,
  WorkspaceCheckResult,
  IssueChallengeResult,
  VerifyChallengeResult,
  ResendChallengeResult,
} from '@app-types/workspaceDiscovery';

// The envelope interceptor unwraps `data`, so each call returns response.data.
// Business outcomes (not-found, expired, cooldown, …) come back HTTP 200 with a
// `messageCode` in the body — only malformed input / 500 reject as errors.
export const workspaceDiscoveryService: WorkspaceDiscoveryApi = {
  async checkWorkspace(workspace) {
    const res = await bffClient.get<WorkspaceCheckResult>('/workspace-check', {
      params: { workspace },
    });
    return res.data;
  },
  async issueChallenge(email, locale) {
    const res = await platformClient.post<IssueChallengeResult>(
      '/v1/workspaces/email-challenge',
      { email, locale },
    );
    return res.data;
  },
  async verifyChallenge(token) {
    const res = await platformClient.post<VerifyChallengeResult>(
      '/v1/workspaces/verify-challenge',
      { token },
    );
    return res.data;
  },
  async resendChallenge(challengeId) {
    const res = await platformClient.post<ResendChallengeResult>(
      '/v1/workspaces/resend-challenge',
      { challengeId },
    );
    return res.data;
  },
};
